var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({ref:"select",staticClass:"app-select",attrs:{"small-chips":_vm.chips,"value":_vm.value,"multiple":_vm.multiple,"menu-props":"offset-y, offset-overflow","deletable-chips":_vm.chips},on:{"change":_vm.onChange,"click:append":_vm.onArrowClick}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }